import { useEffect } from 'react';
import { useAllowedOptions } from '../../../hooks/settings/useAllowedOptions';
import { AllowedOptionColumn } from '../../../components/AllowedOptions/types';
import DefaultLayout from '../../../layout/DefaultLayout';
import AllowedOptionsSelectorTable from '../../../components/AllowedOptions';
import { mapRowToDTO } from '../../../mappers/settings/allowedOptionMapper';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';

const SystemConfigPage = () => {
  const { grouped, fetchGroupedOptions, updateSingleOption, updateOptionList } =
    useAllowedOptions();

  useEffect(() => {
    fetchGroupedOptions();
  }, []);

  const columns: AllowedOptionColumn[] = [
    { label: 'Nombre', key: 'name' },
    {
      label: 'Código',
      key: 'code',
      render: (value) => (
        <span className="bg-gray-100 text-gray-700 inline-block rounded-full px-2 py-0.5 text-xs font-semibold">
          {value}
        </span>
      ),
    },
  ];

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {Object.entries(grouped).map(([module, targets]) =>
          Object.entries(targets).map(([target, rows]) => (
            <AllowedOptionsSelectorTable
              key={`${module}-${target}`}
              title={`${module} · ${target}`}
              rows={rows}
              columns={columns}
              onChangeSingleSelection={(row) =>
                updateSingleOption(mapRowToDTO(row))
              }
              onChangeAllSelection={(updatedRows) =>
                updateOptionList({
                  options: updatedRows.map(mapRowToDTO),
                })
              }
            />
          ))
        )}
      </div>
    </DefaultLayout>
  );
};

export default SystemConfigPage;
